import React from "react";
import { NoteItem } from "./NoteItem";
import style from "./assessmentNotes.module.scss";
import { Spinner } from "../../../secondary/Loader/Spinner";

export const NotesList = ({
  notes,
  assessmentStage,
  onDeleteNote,
  hasPermission,
  handleEditClick,
  editNoteId,
  handleCancelEdit,
  handleSaveEdit,
  editedNote,
  onEditChange,
  onKeyDown,
  updateNoteLoading,
  assessmentNotesLoading,
}) => {
  if (assessmentNotesLoading) return <Spinner />;
  if (!Array.isArray(notes) || notes.length === 0) return null;

  return (
    <div className={style.notes_container}>
      {notes.map((data, index) => (
        <NoteItem
          key={index}
          data={data}
          assessmentStage={assessmentStage}
          onDelete={onDeleteNote}
          hasPermission={hasPermission}
          onEdit={handleEditClick}
          isEditing={editNoteId === data.sourceNoteId}
          onCancelEdit={handleCancelEdit}
          onSaveEdit={handleSaveEdit}
          editedNote={editedNote}
          // onEditChange={(e) => setEditedNote(e.target.value)}
          onEditChange={onEditChange}
          onKeyDown={onKeyDown}
          updateNoteLoading={updateNoteLoading}
        />
      ))}
    </div>
  );
};
